import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  key: 0,
  id: "main-content-port"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = { class: "w90 pad15" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", {
  class: "fl fw600",
  style: {"width":"150px","margin-left":"5%"}
}, "現在のプラン", -1)
const _hoisted_8 = {
  class: "fw400",
  style: {"margin-top":"10px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  width: "280",
  class: "indent2 fs11"
}, "プラン名", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", {
  width: "80",
  class: "fs11"
}, "個数", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", {
  width: "230",
  class: "fs11"
}, "サービスご利用期間", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", {
  width: "300",
  class: "fs11"
}, "継続ステータス", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", {
  width: "180",
  class: "fs11"
}, "翌月お支払い予定額", -1)
const _hoisted_14 = {
  key: 0,
  style: {"height":"60px","border-bottom":"1px solid #ededed"}
}
const _hoisted_15 = { class: "indent2 fw600" }
const _hoisted_16 = { class: "fw600" }
const _hoisted_17 = { class: "fw600 fs11" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "fl" }, "今月末まで", -1)
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "fw600" }, "アクティブ", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "label skyblueBg" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = { class: "w100 pad15" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h5", {
  class: "fl fw600",
  style: {"width":"150px","margin-left":"5%"}
}, "プラン", -1)
const _hoisted_33 = {
  key: 0,
  class: "fl",
  style: {"width":"calc(95% - 200px)"}
}
const _hoisted_34 = {
  key: 1,
  class: "fl",
  style: {"width":"calc(95% - 200px)"}
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = {
  key: 0,
  class: "w90 pad15"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h5", {
  class: "fl fw600",
  style: {"width":"150px","margin-left":"5%"}
}, "お支払い情報", -1)
const _hoisted_42 = ["disabled"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", null, "カード情報を変更する", -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_46 = {
  key: 0,
  class: "ddgrey fs12 ls1 pad10 arial",
  style: {"margin-left":"220px"}
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = { class: "w90 pad15" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h5", {
  class: "fl fw600",
  style: {"width":"150px","margin-left":"5%"}
}, "購入履歴", -1)
const _hoisted_52 = {
  key: 0,
  class: "fw400",
  style: {"margin-top":"10px"}
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("th", {
  width: "120",
  class: "fs11"
}, "金額", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("th", {
  width: "240",
  class: "fs11"
}, "サービスご利用期間", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("th", {
  width: "180",
  class: "fs11"
}, "ステータス", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("th", {
  width: "200",
  class: "fs11"
}, "適用", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("th", {
  class: "fs11",
  style: {"width":"80px"}
}, "受領", -1)
const _hoisted_58 = { key: 0 }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_60 = { class: "fs11" }
const _hoisted_61 = {
  key: 1,
  class: "text-danger fw600 fs11"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "label skyblueBg" }
const _hoisted_65 = { class: "centered" }
const _hoisted_66 = ["href"]
const _hoisted_67 = {
  key: 1,
  style: {"margin-top":"20px"}
}
const _hoisted_68 = ["src"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_AccountHeader = _resolveComponent("AccountHeader")!
  const _component_PlanBox = _resolveComponent("PlanBox")!
  const _component_PlanLoader = _resolveComponent("PlanLoader")!
  const _component_card = _resolveComponent("card")!
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_ModalInnerConfirmChangePlan = _resolveComponent("ModalInnerConfirmChangePlan")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `account` }),
      (_ctx.rm.userInfo && _ctx.rm.userInfo.user_group_role == 100)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createVNode(_component_AccountHeader, { selectedTab: _ctx.selectedTab }, null, 8, ["selectedTab"]),
              _hoisted_5,
              _createElementVNode("section", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("table", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13,
                  (_ctx.currentPlan)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                        _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.currentPlan.name), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.currentPlan.quantity), 1),
                        _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.currentPlan.format), 1),
                        _createElementVNode("td", _hoisted_18, [
                          (_ctx.currentPlan.will_stop)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _hoisted_20,
                                _createTextVNode("    "),
                                _createElementVNode("span", {
                                  class: "fl pink fw600 underline pointer",
                                  style: {"margin-left":"20px"},
                                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelStopSubscription && _ctx.cancelStopSubscription(...args)))
                                }, "変更を取り消す")
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                        ]),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(_ctx.upcomingInvoice.total) + "円（税込） ", 1),
                          _hoisted_24,
                          (_ctx.upcomingInvoice.coupon_name && _ctx.upcomingInvoice.coupon_name.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.upcomingInvoice.coupon_name), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_27,
              _hoisted_28,
              _hoisted_29,
              _hoisted_30,
              _createElementVNode("section", _hoisted_31, [
                _hoisted_32,
                (_ctx.plans)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plans, (plan, planindex) => {
                        return (_openBlock(), _createBlock(_component_PlanBox, {
                          key: `${plan.id}${planindex}${plan.is_current}`,
                          plan: plan,
                          willStop: _ctx.willStop,
                          style: _normalizeStyle(`${planindex == 0 ? `` : `margin-left:2%;`}`),
                          onConfirmChangePlan: _ctx.confirmChangePlan
                        }, null, 8, ["plan", "willStop", "style", "onConfirmChangePlan"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createVNode(_component_PlanLoader, { class: "fl w100" })
                    ]))
              ]),
              _hoisted_35,
              _hoisted_36,
              _hoisted_37,
              _hoisted_38,
              _hoisted_39,
              (_ctx.paymentInfo && _ctx.paymentInfo.registered)
                ? (_openBlock(), _createElementBlock("section", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(_component_card, {
                      class: _normalizeClass(["stripe-card", `roundForm w60 fl yu`]),
                      stripe: _ctx.stripeKey,
                      options: _ctx.stripeOptions,
                      style: `padding:15px;`,
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.complete = $event.complete))
                    }, null, 8, ["stripe", "options"]),
                    _createElementVNode("div", {
                      class: "pay-with-stripe skyblue fw600 pointer fl",
                      style: {"margin-left":"14px","margin-top":"20px"},
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pay && _ctx.pay(...args))),
                      disabled: !_ctx.complete
                    }, _hoisted_44, 8, _hoisted_42),
                    _hoisted_45,
                    (_ctx.paymentInfo && _ctx.paymentInfo.registered)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createTextVNode(" 現在のカード: "),
                          _createElementVNode("span", null, " カード番号: **** **** **** " + _toDisplayString(_ctx.paymentInfo.last4) + "    有効期限: " + _toDisplayString(_ctx.paymentInfo.exp_month) + "/" + _toDisplayString(_ctx.paymentInfo.exp_year), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_47,
              _hoisted_48,
              _hoisted_49,
              _createElementVNode("section", _hoisted_50, [
                _hoisted_51,
                (_ctx.invoices && _ctx.invoices.length > 0)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_52, [
                      _hoisted_53,
                      _hoisted_54,
                      _hoisted_55,
                      _hoisted_56,
                      _hoisted_57,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice, invoiceindex) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "",
                          style: {"height":"60px","border-bottom":"1px solid #ededed"},
                          key: `${invoice.period_start}${invoiceindex}`
                        }, [
                          _createElementVNode("td", null, _toDisplayString(invoice.total.toLocaleString()) + "円", 1),
                          _createElementVNode("td", null, _toDisplayString(invoice.format), 1),
                          _createElementVNode("td", null, [
                            (invoice.paid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                  _createTextVNode(" 購入済み "),
                                  _hoisted_59,
                                  _createElementVNode("span", _hoisted_60, "( " + _toDisplayString(invoice.paid_at_format) + " )", 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                  _createTextVNode(" 決済できませんでした "),
                                  _hoisted_62,
                                  _createTextVNode("お支払い情報を変更してください。 ")
                                ]))
                          ]),
                          _createElementVNode("td", null, [
                            (invoice.coupon_name && invoice.coupon_name.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                  _createElementVNode("span", _hoisted_64, _toDisplayString(invoice.coupon_name), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_65, [
                            _createElementVNode("a", {
                              class: "fs11",
                              target: "_blank",
                              href: `${invoice.hosted_invoice_url}`
                            }, "ダウンロード", 8, _hoisted_66)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      _createTextVNode(" 購入履歴がありません。 "),
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                        width: "24",
                        height: "24"
                      }, null, 8, _hoisted_68)
                    ]))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_69
    ]),
    _createVNode(_component_VueFinalModal, {
      "modal-id": "ConfirmChangePlanModal",
      "content-class": "`ofs with_white_bg modalContent modalNormal`"
    }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_ModalInnerConfirmChangePlan, {
          action: _ctx.action,
          willChangePlan: _ctx.willChangePlan,
          users: _ctx.users,
          paymentInfo: _ctx.paymentInfo,
          complete: _ctx.complete,
          onFixChangePlan: _ctx.fixChangePlan,
          onDismissConfirmChangePlanModal: _ctx.dismissConfirmChangePlanModal
        }, null, 8, ["action", "willChangePlan", "users", "paymentInfo", "complete", "onFixChangePlan", "onDismissConfirmChangePlanModal"])
      ]),
      _: 1
    })
  ]))
}